<template>
  <div class="app_introduction">
    <MpSpeechBubble
      v-if="currentBubble === 1"
      class="speech_bubble1"
      arrowDirection="bottom left"
      arrowPos="20%"
    >
      すきなだんから ちょうせんできるよ！
    </MpSpeechBubble>
    <MpSpeechBubble
      v-if="currentBubble === 2"
      class="speech_bubble2"
    >
      はしをわたって ここまできてね！
    </MpSpeechBubble>
    <MpSpeechBubble
      v-if="currentBubble === 3"
      class="speech_bubble3"
    >
      ぜんぶクリアすると
    </MpSpeechBubble>
    <MpSpeechBubble
      v-if="currentBubble === 4"
      class="speech_bubble4"
      arrowPos="60%"
    >
      ロケットにのって うちゅうへいけるよ
    </MpSpeechBubble>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Howler } from 'howler';
import MpSpeechBubble from "./MpSpeechBubble.vue";

export default {
  components: {
    MpSpeechBubble,
  },
  data() {
    return {
      currentBubble: 0,
      isWaitingOverlay: false,
    };
  },
  computed: {
    ...mapGetters({
      isOverlay: "app/isOverlay",
    }),
  },
  watch: {
    isOverlay(value) {
      if (!value && this.isWaitingOverlay) {
        this.play();
        this.isWaitingOverlay = false;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.isOverlay) {
        this.play();
      } else {
        this.isWaitingOverlay = true;
      }
    });
  },
  beforeDestroy() {
    Howler.stop();
    this.$store.commit("app/setIntroductionStep", 0);
  },
  methods: {
    play() {
      // FIXME: リファクタリング
      this.$store.commit("app/setIsOnIntroduction", true);
      this.$eventBus.$emit("play-hermitCrabA-sway");
      this.$sound.set("new-free/s_k_1.wav").play(null, () => {
        setTimeout(() => {
          this.$store.commit("app/setIntroductionStep", 1);
          this.currentBubble = 1;
          this.$eventBus.$emit('on-single_button-glow');
          this.$sound.set("new-free/s_k_2.wav").play(null, () => {
            setTimeout(() => {
              this.$store.commit("app/setIntroductionStep", 2);
              this.$eventBus.$emit('off-single_button-glow');
              this.$eventBus.$emit('on-bridge-glow');
              this.$eventBus.$emit("stop-hermitCrabA-sway");
              this.$eventBus.$emit("play-hermitCrabB-sway");
              this.currentBubble = 2;
              this.$sound.set("new-free/s_k_3.wav").play(null, () => {
                setTimeout(() => {
                  this.$store.commit("app/setIntroductionStep", 3);
                  this.$eventBus.$emit('off-bridge-glow');
                  this.$eventBus.$emit("play-hermitCrabA-sway");
                  this.currentBubble = 3;
                  this.$eventBus.$emit('on-multi_button-glow');
                  this.$eventBus.$emit('on-single_button-glow');
                  this.$sound.set("new-free/s_k_4.wav").play(null, () => {
                    setTimeout(() => {
                      this.$store.commit("app/setIntroductionStep", 4);
                      this.$eventBus.$emit('off-multi_button-glow');
                      this.$eventBus.$emit('off-single_button-glow');
                      this.$eventBus.$emit("stop-hermitCrabA-sway");
                      this.$eventBus.$emit("stop-hermitCrabB-sway");
                      this.currentBubble = 4;
                      this.$eventBus.$emit('on-rocket-glow');
                      this.$sound.set("new-free/s_k_5.wav").play(null, () => {
                        setTimeout(() => {
                          this.$store.commit("app/setIntroductionStep", 5);
                          this.$eventBus.$emit('off-rocket-glow');
                          this.$eventBus.$emit("play-hermitCrabA-sway");
                          this.$eventBus.$emit("play-hermitCrabB-sway");
                          this.currentBubble = 0;
                          this.$sound.set("new-free/s_k_6.wav").play(null, () => {
                            this.$eventBus.$emit("end-hermitCrabA-sway");
                            this.$eventBus.$emit("end-hermitCrabB-sway");
                            this.$emit("finished");
                            this.$store.commit("app/setIsOnIntroduction", false);
                          });
                        }, 1000);
                      })
                    }, 200)
                  });
                }, 1000);
              });
            }, 1000);
          });
        }, 1000);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app_introduction {
  position: absolute;
  top: 0;
  left: 0;
  width: var(--app-width);
  height: var(--app-height);
  z-index: var(--z-index-screen);

  [class*="speech_bubble"] {
    position: absolute;
  }

  .speech_bubble {
    &1 {
      top: 17%;
      left: 5%;
    }
    &2 {
      top: 58%;
      left: 62%;
    }
    &3 {
      top: 58%;
      left: 62%;
    }
    &4 {
      top: 50%;
      right: 5%;
    }
  }
}
</style>